(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // NOTE: the sticky-add-to-cart custom element itself is registered by
  // the theme's real assets/sticky-add-to-cart.js (handles variant
  // morphing, real cart submission, fly-to-cart animation, etc). That
  // component's own click handler runs the fly-to-cart animation
  // UNCONDITIONALLY, even when the actual form submission gets blocked by
  // the size-selection gate — so to stop the animation from firing before
  // a size is chosen, this listener has to run in the CAPTURE phase
  // (ahead of the real component's handler) and fully stop the click
  // from reaching it when no size is selected.
  // Shared helper: force-refresh the header cart bubble/count + the
  // "YOUR BAG [ n ]" drawer heading directly from /cart.js. Exposed on
  // window so other section scripts (e.g. _size-guide.liquid's mobile
  // auto-add-after-size-pick flow) can call it too — this runs
  // independent of whichever fetch-mutation callback registry catches
  // (or misses) the real add-to-cart request, so the header reliably
  // updates live on mobile instead of only after a manual refresh.
  if (!window.__ensForceRefreshCartUI) {
    window.__ensForceRefreshCartUI = function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasItems = cart.item_count > 0;

          document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('cart-icon').forEach(function (icon) {
            icon.classList.toggle('header-actions__cart-icon--has-cart', hasItems);
          });
          // Prefer toggling the wrapper (see snippets/header-actions.liquid)
          // so a bubble that wasn't rendered on first paint (empty cart)
          // can still be revealed after an add — toggling display on the
          // bubble element itself only works if that element exists yet.
          document.querySelectorAll('.ens-cart-bubble-wrap').forEach(function (wrap) {
            wrap.style.display = hasItems ? 'contents' : 'none';
          });
          document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
            bubble.style.display = hasItems ? '' : 'none';
          });
          document.querySelectorAll('.ens-drawer-count-num').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    };
  }

  // ── Reveal the guide row ("select a size / size guide") ──
  // One-way: once set, data-ens-revealed is never removed, so the row
  // stays visible for the rest of the session (until a real refresh).
  // data-ens-was-revealed is a permanent marker used by the watchdog
  // below to keep it revealed across any re-render that might otherwise
  // wipe the attribute.
  if (!window.__ensRevealGuideRow) {
    window.__ensRevealGuideRow = function (barEl) {
      if (!barEl) return;
      barEl.setAttribute('data-ens-revealed', 'true');
      barEl.setAttribute('data-ens-was-revealed', 'true');
    };
  }

  // ─────────────────────────────────────────────────────────────────
  // Keep the revealed guide row revealed no matter what. Pushed into
  // the same shared cart-mutation-callback registry that already
  // re-syncs the quantity confirmation text and header cart count
  // after every add/change/update/clear.
  // ─────────────────────────────────────────────────────────────────
  window.__ensCartMutationCallbacks = window.__ensCartMutationCallbacks || [];
  window.__ensKeepGuideRevealed = function () {
    document.querySelectorAll('sticky-add-to-cart[data-ens-was-revealed="true"]').forEach(function (bar) {
      if (bar.getAttribute('data-ens-revealed') !== 'true') {
        bar.setAttribute('data-ens-revealed', 'true');
      }
    });
  };
  window.__ensCartMutationCallbacks.push(window.__ensKeepGuideRevealed);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('sticky-add-to-cart [ref="addToCartButton"]');
    if (!btn || btn.disabled) return;

    var bar = btn.closest('sticky-add-to-cart');
    if (!bar) return;

    var section = bar.closest('.shopify-section') || document;
    var productForm = section.querySelector('product-form-component');

    if (productForm && productForm.classList.contains('ens-needs-selection')) {
      // Fallback path — in normal operation the invisible tap guard set
      // up by _size-guide.liquid intercepts the tap first. Either way:
      // this ONLY reveals the "select a size / size guide" row. It does
      // NOT open the size options bar itself — the shopper opens that
      // separately by tapping "select a size".
      e.preventDefault();
      e.stopImmediatePropagation();

      // Remember this attempt so _size-guide.liquid can auto-fire the
      // real add-to-cart click once a size is chosen — this is what
      // makes "Add to Bag" -> pick size -> auto-added work.
      productForm.__ensPendingAddToCart = true;
      productForm.__ensPendingAddTarget = btn;

      if (window.__ensRevealGuideRow) {
        window.__ensRevealGuideRow(bar);
      }
      return;
    }

    // Size chosen — let the click through normally (real component
    // handles the actual add + its own fly-to-cart animation). The
    // confirmation text itself is now driven live by
    // refreshQuantityFromCart() below, via the fetch() interceptor
    // further down — no guessed quantity, no fixed 3s timer.

    // Belt-and-suspenders: if the real add-to-cart handling (or any
    // code it triggers, e.g. after its fetch resolves) kicks off a
    // browser view transition, skip its animation for the next few
    // seconds so nothing cross-fades/flips/flashes on screen — the
    // DOM still updates instantly, just without the visual effect.
    if (window.__suppressNextViewTransition) {
      window.__suppressNextViewTransition();
    }

    // Also kill any CSS transition/animation anywhere on the page for
    // a short window right after the click. Whatever pop-in/jump the
    // theme's own add-to-cart handling does — however it's triggered —
    // this makes the resulting DOM/state change happen instantly
    // instead of animating, without needing to know which element or
    // class is responsible.
    if (window.__suppressNextTransitions) {
      window.__suppressNextTransitions();
    }

    // Belt-and-suspenders header/sticky-bar cart-count refresh — mobile
    // only. Some cart implementations issue their own network request
    // outside of window.fetch (or capture a reference to fetch before
    // this file's wrap below runs), which meant the fetch-mutation
    // callback registry never fired and the header "BAG" count/bubble
    // stayed stale until a manual page refresh. This polls the real
    // cart a few times shortly after the click, independent of how the
    // add actually happened, so the header always catches up without
    // needing a reload. Desktop is untouched — the sticky bar (and this
    // click target) doesn't exist there.
    if (window.matchMedia('(max-width: 749px)').matches) {
      [200, 600, 1200, 2000].forEach(function (delay) {
        setTimeout(function () {
          if (window.__ensForceRefreshCartUI) {
            window.__ensForceRefreshCartUI();
          }
          if (window.__ensKeepGuideRevealed) {
            window.__ensKeepGuideRevealed();
          }
          if (window.__ensCartMutationCallbacks) {
            window.__ensCartMutationCallbacks.forEach(function (cb) {
              try { cb(); } catch (err) { /* no-op */ }
            });
          }
        }, delay);
      });
    }
  }, true);

  // ─── Global transition/animation kill-switch ───
  // Adds a class to <html> that forces every element's transition and
  // animation to none, for a short window after an add-to-cart click.
  window.__suppressNextTransitions = function (durationMs) {
    var root = document.documentElement;
    root.classList.add('atc-no-transition');
    clearTimeout(window.__suppressNextTransitionsTimer);
    window.__suppressNextTransitionsTimer = setTimeout(function () {
      root.classList.remove('atc-no-transition');
    }, durationMs || 900);
  };

  // ─── Suppress view transitions triggered by add-to-cart ───
  // Wraps document.startViewTransition so it can be told, for a short
  // window after an add-to-cart click, to apply the DOM update
  // immediately instead of animating it. Leaves every other use of
  // view transitions on the site (page navigation, variant swaps,
  // etc.) completely untouched.
  (function () {
    if (!document.startViewTransition) return;
    var originalStartViewTransition = document.startViewTransition.bind(document);
    var suppress = false;

    document.startViewTransition = function (callback) {
      if (!suppress) {
        return originalStartViewTransition(callback);
      }
      if (typeof callback === 'function') {
        try {
          callback();
        } catch (err) {
          /* no-op — still avoid breaking the caller */
        }
      }
      return {
        ready: Promise.resolve(),
        updateCallbackDone: Promise.resolve(),
        finished: Promise.resolve(),
        skipTransition: function () {}
      };
    };

    window.__suppressNextViewTransition = function (durationMs) {
      suppress = true;
      clearTimeout(window.__suppressNextViewTransitionTimer);
      window.__suppressNextViewTransitionTimer = setTimeout(function () {
        suppress = false;
      }, durationMs || 3000);
    };
  })();

  // ────────────────────────────────────────────────────────────────
  // Reserve a blank spacer just above the footer (sized to match the
  // sticky bar's live height) so real content — the accordion — never
  // sits under the fixed bar. Dock the bar in place with a single
  // position switch (fixed -> absolute) at the exact moment the spacer
  // reaches the bottom of the viewport, instead of recalculating a
  // transform on every scroll frame.
  //
  // WHY: `position: fixed` is handled entirely by the browser's
  // compositor — zero JS involved while actively scrolling, so it can
  // never lag. A JS-computed `transform`, even a cheap one, always runs
  // one frame behind the browser's own scroll repaint, because it can
  // only react to a scroll event after the scroll has already happened.
  // That unavoidable one-frame lag is what showed up as jitter — it
  // wasn't a matter of the calculation being too expensive, it was
  // architectural. Switching to `position: absolute` at the correct
  // document coordinate is, like `fixed`, compositor-only: once docked,
  // the bar scrolls with the page natively, with no JS in the loop.
  // JS only runs at the two toggle moments (entering/leaving the dock
  // zone), computed to land exactly where the fixed bar already was,
  // so the switch itself is invisible.
  //
  // Never moves the bar in the DOM (an earlier attempt that reparented
  // it into <main> broke the separate script that injects the
  // size-selector variant picker into this bar, since that script's DOM
  // references depend on the bar staying exactly where the theme
  // originally rendered it) — this only ever toggles a class plus one
  // CSS custom property, and the spacer's height.
  // ────────────────────────────────────────────────────────────────
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var bar = null;
    var footer = null;
    var spacer = null;
    var docked = false;
    var ticking = false;
    var cachedBarHeight = 0;

    function findFooter() {
      return (
        document.querySelector('footer') ||
        document.querySelector('[id^="shopify-section-footer"]') ||
        document.querySelector('.shopify-section-footer') ||
        document.querySelector('.footer')
      );
    }

    function ensureSpacer() {
      if (spacer || !footer) return;
      spacer = document.createElement('div');
      spacer.className = 'sticky-atc-footer-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      footer.parentNode.insertBefore(spacer, footer);
    }

    // Called from setup/ResizeObserver only — never from the
    // scroll/touchmove path. Keeps the spacer's height matched to the
    // bar's real rendered height (size slot / guide row included).
    function updateSpacerHeight() {
      if (!bar) return;
      if (!mobileQuery.matches) {
        cachedBarHeight = 0;
        if (spacer) spacer.style.height = '0px';
        return;
      }
      var h = bar.offsetHeight;
      if (h !== cachedBarHeight) {
        cachedBarHeight = h;
        if (spacer) spacer.style.height = h + 'px';
      }
    }

    // Called from setup/ResizeObserver only — never from the
    // scroll/touchmove path. Recomputes the document-absolute Y
    // coordinate the bar should dock at (the spacer's own top), so
    // content changes above the spacer (an accordion item opening, for
    // instance) keep the dock point accurate even while already docked.
    function updateDockTop() {
      if (!bar || !spacer) return;
      var top = spacer.getBoundingClientRect().top + window.scrollY;
      bar.style.setProperty('--sticky-atc-dock-top', top + 'px');
    }

    // Runs on every scroll/touchmove frame. Deliberately does ONLY a
    // single geometry read (spacer position) and, at most, a single
    // classList toggle — and only on the rare frame where the dock
    // state actually changes. No style/transform write happens on the
    // frames in between, so there's nothing to lag behind the
    // compositor.
    function checkDock() {
      ticking = false;
      if (!bar || !spacer) return;

      if (!mobileQuery.matches) {
        if (docked) {
          docked = false;
          bar.classList.remove('sticky-atc-docked');
        }
        return;
      }

      // The fixed bar's visible band is the BOTTOM `cachedBarHeight`
      // pixels of the viewport, not the full viewport — so the dock
      // switch has to fire that many pixels earlier than the viewport
      // edge, at the moment the spacer's top reaches the TOP of that
      // band. Comparing against the full viewport height (the previous
      // version of this check) fired the switch late, letting the bar
      // slide down onto the footer for a beat before docking.
      var dockLine = window.innerHeight - cachedBarHeight;
      var shouldDock = spacer.getBoundingClientRect().top <= dockLine;
      if (shouldDock !== docked) {
        docked = shouldDock;
        bar.classList.toggle('sticky-atc-docked', docked);
      }
    }

    function requestCheck() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(checkDock);
    }

    function setup() {
      bar = document.querySelector('sticky-add-to-cart');
      footer = footer || findFooter();
      ensureSpacer();
      updateSpacerHeight();
      updateDockTop();
      checkDock();
    }

    window.addEventListener('load', setup);
    document.addEventListener('DOMContentLoaded', setup);
    window.addEventListener('scroll', requestCheck, { passive: true });
    window.addEventListener('touchmove', requestCheck, { passive: true });
    window.addEventListener('resize', function () {
      updateSpacerHeight();
      updateDockTop();
      requestCheck();
    });
    window.addEventListener('pageshow', setup);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', setup);
    } else {
      mobileQuery.addListener(setup);
    }
    setup();

    // Height/layout changes (size slot opening, guide row revealing, an
    // accordion item expanding) go through here — never through the
    // scroll/touchmove path.
    if ('ResizeObserver' in window) {
      var barRO = new ResizeObserver(function () {
        updateSpacerHeight();
        updateDockTop();
      });
      window.addEventListener('load', function () {
        if (bar) barRO.observe(bar);
      });

      var footerRO = new ResizeObserver(requestCheck);
      window.addEventListener('load', function () {
        if (footer) footerRO.observe(footer);
      });

      var contentRO = new ResizeObserver(function () {
        updateSpacerHeight();
        updateDockTop();
        requestCheck();
      });
      window.addEventListener('load', function () {
        var contentWrap = document.querySelector('main') || document.body;
        if (contentWrap) contentRO.observe(contentWrap);
      });
    }
  })();

  // ────────────────────────────────────────────────────────────────
  // LIVE "X IN BAG" SYNC
  // Replaces the old one-shot "X quantity added" text (which showed a
  // guessed number and auto-hid after a fixed 3s). This reads the
  // REAL cart every time it changes, so the sticky bar always shows
  // the true quantity of THIS variant — and correctly drops/hides
  // when the header cart drawer removes or decreases the same line
  // item, not just when this bar's own button is clicked.
  //
  // SPEED + ACCURACY FIX: instead of guessing which custom event name
  // this theme's cart drawer fires (which may not match, causing
  // "shows really slow" / "decrease doesn't reflect"), this wraps
  // window.fetch and reacts the instant ANY request to a Shopify cart
  // endpoint (/cart/add, /cart/change, /cart/update, /cart/clear)
  // resolves — regardless of which UI element triggered it. That
  // covers this sticky bar's own add AND every quantity +/- or remove
  // action in the header/cart drawer, since those all go through the
  // same cart endpoints under the hood.
  // ────────────────────────────────────────────────────────────────
  // reveal = true: a real add / remove happened, so show the text and
  // hide it again after window.__ensConfirmationMs. Anything else (page
  // load, option change) only keeps the number current.
  function refreshQuantityFromCart(reveal) {
    reveal = reveal === true;
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar) return;
    var productId = bar.dataset.productId;
    if (!productId) return;

    // Shared, de-duplicated /cart.js request (also used by the main
    // add-to-cart confirmation), so one click is one network call.
    var getCart = window.__ensGetCart || function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); });
    };

    getCart()
      .then(function (cart) {
        // Total for this PRODUCT across all variants (every size and
        // with / without back print), not just the selected variant.
        var qty = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.product_id) === String(productId)) qty += item.quantity;
        });

        var confirmation = bar.querySelector('[ref="addedConfirmation"]');
        var qtyText = bar.querySelector('[ref="addedQtyText"]');
        if (!confirmation || !qtyText) return;

        if (qty <= 0) {
          clearTimeout(bar.__confirmationTimer);
          confirmation.style.display = 'none';
          return;
        }

        qtyText.textContent = qty;
        confirmation.textContent = '';
        confirmation.appendChild(qtyText);
        confirmation.appendChild(document.createTextNode(' quantity added'));
        if (!reveal) return;

        confirmation.style.display = 'block';
        clearTimeout(bar.__confirmationTimer);
        bar.__confirmationTimer = setTimeout(function () {
          confirmation.style.display = 'none';
        }, window.__ensConfirmationMs || 3000);
      })
      .catch(function () {});
  }

  // Exposed so other scripts (specifically blocks/_size-guide.liquid's
  // sticky-bar-re-render resync — see the comment there) can ask the
  // confirmation line to recompute itself for whichever variant is
  // currently selected, instead of leaving it however the theme's own
  // re-render last left it.
  window.__ensRefreshStickyBarQuantity = refreshQuantityFromCart;

  (function () {
    var CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

    function isCartMutationUrl(url) {
      if (!url) return false;
      for (var i = 0; i < CART_ENDPOINTS.length; i++) {
        if (url.indexOf(CART_ENDPOINTS[i]) !== -1) return true;
      }
      return false;
    }

    // Shared registry: any part of the theme (this sticky bar, the
    // header cart bubble, etc.) can push a callback here to be notified
    // the instant a /cart/* endpoint resolves — without each file
    // wrapping window.fetch separately.
    window.__ensCartMutationCallbacks = window.__ensCartMutationCallbacks || [];
    window.__ensCartMutationCallbacks.push(function () {
      refreshQuantityFromCart(true);
    });

    // Only wrap fetch once even if this runs on multiple sections/pages.
    if (!window.__ensCartFetchWrapped) {
      window.__ensCartFetchWrapped = true;
      var originalFetch = window.fetch.bind(window);

      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mutating = isCartMutationUrl(url);
        var promise = originalFetch(input, init);

        if (mutating) {
          promise.then(function () {
            window.__ensCartMutationCallbacks.forEach(function (cb) {
              try { cb(); } catch (err) { /* no-op */ }
            });
          }).catch(function () {});
        }

        return promise;
      };
    }

    // Belt-and-braces: also listen for common custom cart events, in
    // case any part of the theme updates the cart without going
    // through fetch (e.g. a form submit that isn't intercepted).
    ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'cart:build']
      .forEach(function (name) {
        document.addEventListener(name, function () { refreshQuantityFromCart(true); });
        document.addEventListener(name, window.__ensKeepGuideRevealed);
      });

    // Second belt-and-braces: watch the header's cart-count badge text
    // directly, so even a theme with a totally different event/fetch
    // pattern still syncs.
    function watchCartBadge() {
      var countEl = document.querySelector(
        '[data-testid="cart-count"], .cart-count, .cart-bubble__text-count'
      );
      if (!countEl || !('MutationObserver' in window)) return;
      new MutationObserver(function () { refreshQuantityFromCart(false); }).observe(countEl, {
        characterData: true,
        childList: true,
        subtree: true
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchCartBadge, { once: true });
    } else {
      watchCartBadge();
    }

    // The variant picker re-renders (morphs) the sticky bar, which resets
    // its text. Re-sync once it has settled.
    document.addEventListener('variant:update', function () {
      refreshQuantityFromCart(false);
      setTimeout(function () { refreshQuantityFromCart(false); }, 350);
    });

    // Keep it correct across full page loads / bfcache restores too.
    document.addEventListener('DOMContentLoaded', function () { refreshQuantityFromCart(false); });
    window.addEventListener('load', function () { refreshQuantityFromCart(false); });
    window.addEventListener('pageshow', function () { refreshQuantityFromCart(false); });
  })();

  // ────────────────────────────────────────────────────────────────
  // WATCHDOG: belt-and-suspenders in case something outside the hooks
  // above ever un-reveals the guide row again (a theme re-render path
  // we haven't seen, a stray attribute wipe, etc). Runs a cheap check
  // twice a second on mobile only and simply re-asserts the revealed
  // state for any bar that was genuinely revealed earlier in this
  // session — this is what guarantees "stays fixed until refresh"
  // regardless of what else is happening on the page. It never reveals
  // a bar that hasn't actually been revealed yet (no data-ens-was-
  // revealed marker), so it can't accidentally show the row early.
  // ────────────────────────────────────────────────────────────────
  (function () {
    function tick() {
      if (window.matchMedia('(max-width: 749px)').matches && window.__ensKeepGuideRevealed) {
        window.__ensKeepGuideRevealed();
      }
    }
    setInterval(tick, 500);
    document.addEventListener('DOMContentLoaded', tick);
    window.addEventListener('load', tick);
    window.addEventListener('pageshow', tick);
  })();

  } catch(e) { console.error(e); }
})();
})();
